<div class="wrapper">
	<a [routerLink]="itemLink()" class="table-link">{{
		item.title || "[Namnlös]"
	}}</a>
</div>
